import Vue from "vue"
import App from "@/App.vue"
import router from "@/router.js"
import Auth from "@/script/Auth.js"

new Vue({
    router,
    Auth,
    render: h => h(App),
}).$mount("#app");